import { MarketingChannel } from "@redotech/redo-billing-common/marketing-channel";
import { TextRedoListItem } from "@redotech/redo-web/arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "@redotech/redo-web/arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { memo } from "react";

const channelFilterOptions: TextRedoListItem<ChannelFilter>[] = [
  { id: "all", type: "text", text: "Email & SMS", value: "all" },
  { id: "email", type: "text", text: "Email", value: MarketingChannel.EMAIL },
  { id: "sms", type: "text", text: "SMS", value: MarketingChannel.SMS },
];

export const MarketingChannelFilter = memo(function MarketingChannelFilter({
  channelFilter,
  setChannelFilter,
}: {
  channelFilter: ChannelFilter;
  setChannelFilter: (value: ChannelFilter) => void;
}) {
  const selectedOption = channelFilterOptions.find(
    (option) => option.value === channelFilter,
  );

  return (
    <RedoSingleSelectDropdownInput<ChannelFilter>
      fitToAnchor={false}
      flexGrow={false}
      label="Channel"
      options={channelFilterOptions}
      optionSelected={({ item }) => setChannelFilter(item.value)}
      selectedItem={selectedOption}
      size="xs"
    />
  );
});

export type ChannelFilter = "all" | MarketingChannel;

export interface ChannelFilterDropdownProps {
  value: ChannelFilter;
  onChange: (value: ChannelFilter) => void;
}

export function getChannelsForFilter(
  channelFilter: ChannelFilter,
): MarketingChannel[] | undefined {
  return channelFilter === "all" ? undefined : [channelFilter];
}
